import { useQuery, useMutation } from "@tanstack/react-query";
import { api } from "@/utils/axiosInterceptor";
import { SupplierData } from "@/types/supplier";

export const useSuppliers = () => {
	const {
		data: suppliers,
		isLoading,
		error,
	} = useQuery({
		queryKey: ["suppliers"],
		queryFn: async () => {
			const response = await api.get<SupplierData[]>("/suppliers")
			return response;
		},
	});

	const createSupplierMutation = useMutation({
		mutationFn: (supplier: Omit<SupplierData, "id">) => 
            api.post<SupplierData>("/supplier", supplier),
	});

	const updateSupplierMutation = useMutation({
		mutationFn: (supplier: Partial<SupplierData>) =>
			api.put<SupplierData>(`/supplier/${supplier.id}`, supplier)
	});

	const deleteSupplierMutation = useMutation({
		mutationFn: (id: string) => api.delete(`/supplier/${id}`),
	});

	return {
		suppliers,
		createSupplierAsync: createSupplierMutation.mutateAsync,
		updateSupplier: updateSupplierMutation.mutateAsync,
		deleteSupplierAsync: deleteSupplierMutation.mutateAsync,
		isLoading,
		error,
	};
};
